import { createContext } from "react";

export const SubscriptionContext = createContext();

export const initialSubscriptionState = {'subscriptionAccesses':{}};